import React from 'react'
import AnimatePage from '../components/AnimatePage'
import { BsFillCheckCircleFill } from "react-icons/bs";
import Wrapper from '../helpers/Wrapper';
import CustomiseChat from '../components/Customisations/CustomiseChat';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../helpers/Axios';
import { VscError } from 'react-icons/vsc';
import { IoWalletOutline } from 'react-icons/io5';


function SucessOrder() {

    // eslint-disable-next-line
    const [searchParams, setSearchParam] = useSearchParams();

    // eslint-disable-next-line
    const { data, isLoading, status } = useQuery({
        queryKey: ['makingpayment'],
        queryFn: async () => {
            const res = await apiClient('/payment/verify', { params: { reference: searchParams.get('reference') } })
            return res.data
        }
    })


    if (isLoading) {
        return (
            <AnimatePage>
                <div className="h-[500px] flex justify-center items-center">
                    <div className="flex items-center justify-center gap-2 animate-pulse text-gray-700">
                        <IoWalletOutline size={25} />
                        <p className='font-serif'>Making Payment</p>
                    </div>
                </div>
            </AnimatePage>
        )
    }

    if (status === 'error') {
        return (
            <div className="text-red-500 text-sm my-5 flex gap-2 items-center capitalize justify-center">
                <VscError />
                Error Occured While making payment
            </div>
        )
    }

    if (status === 'success') {
        return (
            <AnimatePage>
                <div className='mt-12 w-full relative h-full my-10'>
                    <Wrapper>
                        {/* 1rst One */}
                        <div className="mt-7">

                            {/* Check Mark */}
                            <div className="items-center flex justify-center">
                                <div className="rounded-full text-green-600 border-[10px] border-green-300/60 ring-8 ring-green-500/20">
                                    <BsFillCheckCircleFill size={50} />
                                </div>
                            </div>

                            {/* Content */}
                            <div className="w-full relative mt-5">
                                <h1 className="text-2xl font-medium sm:text-3xl font-serif text-center">
                                    Thank you for your purchase
                                </h1>
                                <p className="text-gray-500 text-center mt-4 text-[clamp(0.95rem,2vw+1rem,1.02rem)] max-w-[600px] mx-auto">
                                    We’re thrilled to have you as a customer. Your order has been placed successfully, and we’re getting it ready for you
                                </p>
                            </div>
                        </div>


                        {/* Chat Section */}
                        <div className="mt-12">
                            <CustomiseChat />
                        </div>
                    </Wrapper>
                </div>
            </AnimatePage>
        )
    }
}

export default SucessOrder